import { Reveal, Chapter } from "./shared";

const FACTORS = [
  {
    title: "Glazed area",
    body: "Priced per square metre of glass treated.",
  },
  {
    title: "Sun exposure",
    body: "Most clients start with the worst sun-facing elevations.",
  },
  {
    title: "Access & glass type",
    body: "Tall glazing or very old glass takes longer to prepare.",
  },
];

export default function Pricing() {
  return (
    <section id="pricing" data-testid="pricing-section" className="py-16 md:py-20">
      <div className="max-w-7xl mx-auto px-5 md:px-10">
        <Chapter title="Pricing" />
        <Reveal>
          <p
            data-testid="pricing-text"
            className="max-w-2xl text-base md:text-lg text-slate-600 leading-relaxed"
          >
            Every job gets its own written quotation. There is no fixed price list,
            because the price depends on a few factors that are different on every
            site:
          </p>
        </Reveal>

        <div
          data-testid="pricing-factors"
          className="mt-8 grid sm:grid-cols-3 gap-4 md:gap-5"
        >
          {FACTORS.map((f, i) => (
            <Reveal
              key={f.title}
              delay={i * 0.08}
              className="border border-slate-300 bg-white p-6"
            >
              <h3 className="font-heading font-bold text-lg text-slate-900">
                {f.title}
              </h3>
              <p className="mt-2 text-sm text-slate-600 leading-relaxed">{f.body}</p>
            </Reveal>
          ))}
        </div>

        <Reveal delay={0.15}>
          <p className="mt-8 max-w-2xl text-base md:text-lg text-slate-600 leading-relaxed">
            Your quote is measured on your own glazing, fixed in writing before we
            start, and it doesn't change afterwards.
          </p>
        </Reveal>
      </div>
    </section>
  );
}
